import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4),
    backgroundColor: theme.colorPalette.green_100,
    marginBottom: theme.spacing(4),
    ...reskinStyles(theme, { border: 'none' })
  },
  errorCard: {
    backgroundColor: theme.colorPalette.red_100
  },
  label: {
    display: 'contents',
    fontWeight: 400
  },
  button: {
    width: 180,
    padding: theme.spacing(3, 4),
    display: 'flex',
    '& > span': {
      fontSize: 12,
      fontWeight: 600
    },
    ...reskinStyles(theme, { '& > span': { fontSize: 12, fontWeight: 600, color: theme.colorPalette.beige_50 } })
  },
  chevronRightIcon: {
    marginLeft: theme.spacing(2)
  }
}));

export default useStyles;
